"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClickGame = void 0;
// import { triggerBalanceByCurrency } from '@l2p/apps-shared';
// import * as Lockr from 'lockr';
// import { useBalance, useFreespinsCards, useIsAuthorized } from '@l2p/swr-hooks';
var swr_hooks_1 = require("@l2p/swr-hooks");
var navigation_1 = require("next/navigation");
var react_1 = require("react");
// import { FreeRoundStatus } from '@l2p/profile-api';
// import { differenceInHours } from 'date-fns';
// const GAME_PLAY_CLICKED = 'gamePlayClicked';
// const frequencyNotification = 1;
var useClickGame = function () {
    var router = (0, navigation_1.useRouter)();
    var config = (0, swr_hooks_1.useConfig)();
    var openInNewTab = config === null || config === void 0 ? void 0 : config.openGameInNewTab;
    // const openDeposit = useOpenDeposit();
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    // const { freespins } = useFreespinsCards();
    // const activeFreespins = useMemo(() => {
    //   return freespins.find(
    //     (bonus) => bonus.status === FreeRoundStatus.InProgress,
    //   );
    // }, [freespins]);
    // const { data: balanceData } = useBalance();
    var onClickPlay = (0, react_1.useCallback)(function (url) {
        if (openInNewTab && isAuth) {
            window.open(url, '_blank');
            return;
        }
        return router.push(url);
        // const balance = parseFloat(balanceData?.totalAmount || '0');
        // if (!isAuth || !balanceData?.currency) return router.push(url);
        //
        // if ((activeFreespins?.amount || 0) > 0) return router.push(url);
        //
        // const clickDate = Lockr.get(GAME_PLAY_CLICKED);
        //
        // const isOpenDepositAllowed =
        //   !clickDate ||
        //   differenceInHours(new Date(), new Date(clickDate)) >=
        //     frequencyNotification;
        //
        // if (!isOpenDepositAllowed) return router.push(url);
        //
        // if (triggerBalanceByCurrency?.[balanceData.currency] >= balance) {
        //   Lockr.set(GAME_PLAY_CLICKED, new Date());
        //   openDeposit(`back=${url}`);
        // } else {
        //   router.push(url);
        // }
    }, [router, openInNewTab, isAuth]);
    return {
        onClickPlay: onClickPlay,
    };
};
exports.useClickGame = useClickGame;
